var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"image--container",style:({maxWidth: _vm.containerWidth + 'px', maxHeight: _vm.containerHeight + 'px', overflow: 'hidden'})},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.cdnUrl),expression:"cdnUrl"}],ref:"image",style:({width: _vm.loaded ? '100%' : (_vm.placeholderWidth + 'px')})})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4f7f85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/image.component.vue
// module id = null
// module chunks = 